export default __webpack_public_path__ + "images/1064c680b7131f5d18e1ba3ac13da9ab.gif";